module.exports = __webpack_public_path__ + "static/Zombie-abf142b19ac44b3a6e7cff50f1668f27.jpg";